import { MdOutlineFormatBold } from "react-icons/md";
import { FaItalic, FaStrikethrough, FaUnderline } from "react-icons/fa";
import { TopButton } from "./TopButton";
import { useGetEditor } from "../../../context/useEditorContext";
import { Seperator } from "./Seperator";
import { IconsContainer } from "./IconsContainer";

function TextAlterations() {
    const editor = useGetEditor().editor.current;

    return (
        <IconsContainer>
            <TopButton
                isActive={editor?.isActive("bold")}
                icon={<MdOutlineFormatBold size={24} className="mt-[1px]" />}
                onClick={(e) => {
                    e.preventDefault();
                    editor?.commands.toggleBold();
                    editor?.commands.focus();
                }}
                alt="Toggle bold"
            />
            <TopButton
                icon={<FaItalic size={16} />}
                isActive={editor?.isActive("italic")}
                onClick={(e) => {
                    editor?.commands.toggleItalic();
                    editor?.commands.focus();
                }}
                alt="Toggle italic"
            />
            <TopButton
                icon={<FaUnderline size={16} className="mt-[2px]" />}
                isActive={editor?.isActive("underline")}
                onClick={(e) => {
                    editor?.commands.toggleUnderline();
                    editor?.commands.focus();
                }}
                alt="Toggle underline"
            />
            <TopButton
                icon={<FaStrikethrough size={16} />}
                isActive={editor?.isActive("strike")}
                onClick={(e) => {
                    editor?.commands.toggleStrike();
                    editor?.commands.focus();
                }}
                alt="Toggle strikethrough"
            />
            <Seperator />
        </IconsContainer>
    );
}

export default TextAlterations;
